"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STROKE_STYLE = exports.STROKE_STYLES = exports.DEFAULT_STROKE_WIDTH = exports.DEFAULT_STROKE_COLOR = exports.DEFAULT_VERTICAL_PADDING_FOR_TEXT = exports.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT = exports.DEFAULT_TOP_PADDING_FOR_TEXT = exports.DEFAULT_ARBITRARY_OVERFLOW_PADDING_IN_PIXELS = exports.FONT_SIZE_MAX_IN_PIXELS = exports.FONT_SIZE_MIN_IN_PIXELS = exports.MAX_TEXT_CHARS = exports.UNICODES = exports.DEFAULT_TEXT_EFFECTS_OBJECTS = exports.HIGHLIGHT_SIZE_OPTIONS = exports.TEXT_EFFECTS = exports.DEFAULT_LINE_SPACING = exports.DEFAULT_LETTER_SPACING = exports.VALID_OVERFLOW_Y = exports.OVERFLOW_Y = exports.VALID_OVERFLOW_X = exports.OVERFLOW_X = exports.DEFAULT_VERTICAL_TEXT_ALIGNMENT = exports.VALID_VERTICAL_TEXT_ALIGNMENT = exports.VERTICAL_TEXT_ALIGNMENT = exports.DEFAULT_FONT_SIZE = exports.TEXT_ALIGNMENT = exports.TEXT_DIRECTION = exports.DEFAULT_TEXT_FILL_PROPERTIES = exports.DEFAULT_TEXT_FILL = exports.TEXT_FILL = exports.VALID_TEXT_TYPES = exports.DEFAULT_TEXT_TYPE = exports.TEXT_TYPE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _DEFAULT_TEXT_EFFECTS;

var TEXT_TYPE = {
  CANVAS: 'CANVAS',
  SVG: 'SVG'
};
exports.TEXT_TYPE = TEXT_TYPE;
var DEFAULT_TEXT_TYPE = TEXT_TYPE.SVG;
exports.DEFAULT_TEXT_TYPE = DEFAULT_TEXT_TYPE;
var VALID_TEXT_TYPES = new Set(Object.keys(TEXT_TYPE));
exports.VALID_TEXT_TYPES = VALID_TEXT_TYPES;
var TEXT_FILL = {
  ABSOLUTE: 'ABSOLUTE',
  AUTO: 'AUTO',
  GROW_TO_FIT: 'GROW_TO_FIT',
  SHRINK_TO_FIT: 'SHRINK_TO_FIT'
};
exports.TEXT_FILL = TEXT_FILL;
var DEFAULT_TEXT_FILL = TEXT_FILL.ABSOLUTE;
exports.DEFAULT_TEXT_FILL = DEFAULT_TEXT_FILL;
var DEFAULT_TEXT_FILL_PROPERTIES = {
  mode: DEFAULT_TEXT_FILL
};
exports.DEFAULT_TEXT_FILL_PROPERTIES = DEFAULT_TEXT_FILL_PROPERTIES;
var TEXT_DIRECTION = {
  LTR: 'ltr',
  RTL: 'rtl'
};
exports.TEXT_DIRECTION = TEXT_DIRECTION;
var TEXT_ALIGNMENT = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
};
exports.TEXT_ALIGNMENT = TEXT_ALIGNMENT;
var DEFAULT_FONT_SIZE = 96;
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
var VERTICAL_TEXT_ALIGNMENT = {
  BOTTOM: 'BOTTOM',
  MIDDLE: 'MIDDLE',
  TOP: 'TOP'
};
exports.VERTICAL_TEXT_ALIGNMENT = VERTICAL_TEXT_ALIGNMENT;
var VALID_VERTICAL_TEXT_ALIGNMENT = new Set(Object.keys(VERTICAL_TEXT_ALIGNMENT));
exports.VALID_VERTICAL_TEXT_ALIGNMENT = VALID_VERTICAL_TEXT_ALIGNMENT;
var DEFAULT_VERTICAL_TEXT_ALIGNMENT = VERTICAL_TEXT_ALIGNMENT.TOP;
exports.DEFAULT_VERTICAL_TEXT_ALIGNMENT = DEFAULT_VERTICAL_TEXT_ALIGNMENT;
var OVERFLOW_X = {
  HIDDEN: 'HIDDEN',
  VISIBLE: 'VISIBLE',
  WRAP: 'WRAP'
};
exports.OVERFLOW_X = OVERFLOW_X;
var VALID_OVERFLOW_X = new Set(Object.keys(OVERFLOW_X));
exports.VALID_OVERFLOW_X = VALID_OVERFLOW_X;
var OVERFLOW_Y = {
  ELLIPSIS: 'ELLIPSIS',
  HIDDEN: 'HIDDEN',
  VISIBLE: 'VISIBLE'
};
exports.OVERFLOW_Y = OVERFLOW_Y;
var VALID_OVERFLOW_Y = new Set(Object.keys(OVERFLOW_Y));
exports.VALID_OVERFLOW_Y = VALID_OVERFLOW_Y;
var DEFAULT_LETTER_SPACING = 0;
exports.DEFAULT_LETTER_SPACING = DEFAULT_LETTER_SPACING;
var DEFAULT_LINE_SPACING = 1.2;
exports.DEFAULT_LINE_SPACING = DEFAULT_LINE_SPACING;
var TEXT_EFFECTS = {
  NONE: 'NONE',
  DROP_SHADOW: 'DROP_SHADOW',
  OUTER_GLOW: 'OUTER_GLOW',
  INNER_SHADOW: 'INNER_SHADOW',
  BOX_FILL: 'BOX_FILL',
  LINE_FILL: 'LINE_FILL',
  FIT_LINE_FILL: 'FIT_LINE_FILL',
  OUTLINE_STROKE: 'OUTLINE_STROKE',
  BEVEL: 'BEVEL',
  DROP_SHADOW_OUTLINE: 'DROP_SHADOW_OUTLINE',
  HIGHLIGHT: 'HIGHLIGHT'
};
exports.TEXT_EFFECTS = TEXT_EFFECTS;
var HIGHLIGHT_SIZE_OPTIONS = {
  TEXT: 'TEXT',
  LINE: 'LINE'
};
exports.HIGHLIGHT_SIZE_OPTIONS = HIGHLIGHT_SIZE_OPTIONS;
var DEFAULT_TEXT_EFFECTS_OBJECTS = (_DEFAULT_TEXT_EFFECTS = {}, (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.NONE, {
  type: TEXT_EFFECTS.NONE,
  color: '#000000',
  size: 0,
  boxPadding: 0,
  blur: 0,
  borderRadius: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.DROP_SHADOW, {
  type: TEXT_EFFECTS.DROP_SHADOW,
  color: '#000000',
  size: 0,
  boxPadding: 0,
  blur: 5,
  borderRadius: 0,
  opacity: 50,
  xOffset: 5,
  yOffset: 5
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.OUTER_GLOW, {
  type: TEXT_EFFECTS.OUTER_GLOW,
  color: '#000000',
  size: 5,
  boxPadding: 0,
  blur: 0,
  borderRadius: 0,
  opacity: 50,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.INNER_SHADOW, {
  type: TEXT_EFFECTS.INNER_SHADOW,
  color: '#000000',
  size: 0,
  boxPadding: 0,
  blur: 5,
  borderRadius: 0,
  opacity: 100,
  xOffset: 2,
  yOffset: 2
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.BOX_FILL, {
  type: TEXT_EFFECTS.BOX_FILL,
  color: '#242422',
  size: 0,
  boxPadding: 0,
  blur: 0,
  borderRadius: 0,
  opacity: 80,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.LINE_FILL, {
  type: TEXT_EFFECTS.LINE_FILL,
  color: '#242422',
  size: 12,
  boxPadding: 0,
  blur: 0,
  borderRadius: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.FIT_LINE_FILL, {
  type: TEXT_EFFECTS.FIT_LINE_FILL,
  color: '#242422',
  size: 12,
  boxPadding: 0,
  blur: 0,
  borderRadius: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.OUTLINE_STROKE, {
  type: TEXT_EFFECTS.OUTLINE_STROKE,
  color: '#fffc00',
  size: 10,
  blur: 50,
  borderRadius: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.BEVEL, {
  type: TEXT_EFFECTS.BEVEL,
  color: '#ffffff',
  size: 10,
  blur: 0,
  borderRadius: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.DROP_SHADOW_OUTLINE, {
  type: TEXT_EFFECTS.DROP_SHADOW_OUTLINE,
  color: '#000000',
  size: 5,
  blur: 50,
  borderRadius: 0,
  opacity: 30,
  xOffset: 5,
  yOffset: 5
}), (0, _defineProperty2["default"])(_DEFAULT_TEXT_EFFECTS, TEXT_EFFECTS.HIGHLIGHT, {
  type: TEXT_EFFECTS.HIGHLIGHT,
  color: '#242422',
  size: HIGHLIGHT_SIZE_OPTIONS.TEXT,
  borderRadius: 0,
  boxPadding: 0,
  blur: 0,
  opacity: 100,
  xOffset: 0,
  yOffset: 0
}), _DEFAULT_TEXT_EFFECTS);
exports.DEFAULT_TEXT_EFFECTS_OBJECTS = DEFAULT_TEXT_EFFECTS_OBJECTS;
var UNICODES = {
  ELLIPSIS: "\u2026"
};
exports.UNICODES = UNICODES;
var MAX_TEXT_CHARS = 4800;
exports.MAX_TEXT_CHARS = MAX_TEXT_CHARS;
var FONT_SIZE_MIN_IN_PIXELS = 24;
exports.FONT_SIZE_MIN_IN_PIXELS = FONT_SIZE_MIN_IN_PIXELS;
var FONT_SIZE_MAX_IN_PIXELS = 1200;
exports.FONT_SIZE_MAX_IN_PIXELS = FONT_SIZE_MAX_IN_PIXELS;
var DEFAULT_ARBITRARY_OVERFLOW_PADDING_IN_PIXELS = 2000;
exports.DEFAULT_ARBITRARY_OVERFLOW_PADDING_IN_PIXELS = DEFAULT_ARBITRARY_OVERFLOW_PADDING_IN_PIXELS;
var DEFAULT_TOP_PADDING_FOR_TEXT = 0.96;
exports.DEFAULT_TOP_PADDING_FOR_TEXT = DEFAULT_TOP_PADDING_FOR_TEXT;
var DEFAULT_HORIZONTAL_PADDING_FOR_TEXT = 0.16;
exports.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT = DEFAULT_HORIZONTAL_PADDING_FOR_TEXT;
var DEFAULT_VERTICAL_PADDING_FOR_TEXT = 0.16;
exports.DEFAULT_VERTICAL_PADDING_FOR_TEXT = DEFAULT_VERTICAL_PADDING_FOR_TEXT;
var DEFAULT_STROKE_COLOR = '#FF0000';
exports.DEFAULT_STROKE_COLOR = DEFAULT_STROKE_COLOR;
var DEFAULT_STROKE_WIDTH = 0;
exports.DEFAULT_STROKE_WIDTH = DEFAULT_STROKE_WIDTH;
var STROKE_STYLES = {
  BEVEL: 'bevel',
  MITER: 'miter',
  ROUND: 'round'
};
exports.STROKE_STYLES = STROKE_STYLES;
var DEFAULT_STROKE_STYLE = STROKE_STYLES.ROUND;
exports.DEFAULT_STROKE_STYLE = DEFAULT_STROKE_STYLE;